import styled from 'styled-components';
import { Table } from '@thinknet-gmbh/platform-common-ui';

export const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  > div {
    width: 100%;
  }
`;

export const StyledPreviewTableContainer = styled(Table)`
  .ant-table-content {
    overflow: visible !important;
  }
`;
